import {
  SentimentDissatisfiedRounded,
  SentimentNeutralRounded,
  SentimentVeryDissatisfiedRounded,
  SentimentVerySatisfiedRounded,
} from '@mui/icons-material'
import { Box, SxProps, Typography } from '@mui/material'
import { ChangeEvent } from 'react'

interface Props {
  title: string
  value: number
  onChange: (v: number) => void
}

export default function SatisfactionSlider(props: Props): JSX.Element {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(Number(e.target.value))
  }

  return (
    <Box sx={containerStyle}>
      <Typography sx={questionStyle}>{props.title}</Typography>
      <Box sx={sliderContainerStyle}>
        <Box
          component="input"
          type="range"
          min={1}
          max={100}
          value={props.value}
          onChange={handleChange}
          sx={sliderStyle}
        />
      </Box>
      <Box sx={facesStyle}>
        <SentimentVeryDissatisfiedRounded
          sx={{ color: '#FF005A', fontSize: '32px' }}
        />
        <SentimentDissatisfiedRounded
          sx={{ color: '#CF46A8', fontSize: '32px' }}
        />
        <SentimentNeutralRounded sx={{ color: '#6B7ACE', fontSize: '32px' }} />
        <SentimentVerySatisfiedRounded
          sx={{ color: '#14AAD3', fontSize: '32px' }}
        />
      </Box>
    </Box>
  )
}

const containerStyle: SxProps = {
  padding: '30px',
  textAlign: 'center',
}

const questionStyle: SxProps = {
  fontWeight: 'bold',
  fontSize: '24px',
  marginBottom: '20px',
  textAlign: 'left',
}

const sliderContainerStyle: SxProps = {
  position: 'relative',
  width: 'calc(100% - 32px)',
  margin: '0 auto 20px auto',
}

const sliderStyle: SxProps = {
  WebkitAppearance: 'none',
  width: '100%',
  height: '8px',
  borderRadius: '5px',
  background: 'linear-gradient(to right, #f50057, #00e5ff)',
  outline: 'none',
  '::-webkit-slider-thumb': {
    WebkitAppearance: 'none',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'white',
    border: '4px solid #333',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
  '::-moz-range-thumb': {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    background: 'white',
    border: '4px solid #555',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
  },
}

const facesStyle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 auto',
  fontSize: '20px',
}
